// extracted by mini-css-extract-plugin
export default {"MapPoint":"MapPoint_MapPoint__gTSeK"};